const defaultReservedWords = ['false', 'null', 'true', 'undefined'];

interface IRemoveReservedWordsProps {
  text: string;
  reservedWords?: string[];
}

const removeReservedWordsFromString = ({ text, reservedWords = defaultReservedWords }: IRemoveReservedWordsProps) => {
  return reservedWords.some((word) => word === text.trim().toLowerCase()) ? '' : text;
};

const removeHTMLfromText = (text: string) => {
  const pattern = /<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>/gi;

  return text.replace(pattern, '');
};

export { removeReservedWordsFromString, removeHTMLfromText };
